import React, { useEffect, useRef, useState } from "react";
import ReusableDataTable from "../../Component/DataTable/ReusableDataTablePrime";
import { Autocomplete, Box, Button, Checkbox, FormControl, FormControlLabel, FormGroup, Grid, IconButton, MenuItem, Popover, Select, TextField, Typography } from "@mui/material";
import { OverlayPanel } from "primereact/overlaypanel";
import ReusablePrimeButton from "../../Component/Buttons/ReusablePrimeButton";
import { useDispatch, useSelector } from "react-redux";
import { DataTable } from "primereact/datatable";
import { FilterMatchMode } from "primereact/api";
import { getStockColumn, getStockColumns, stockBodyTableIcon } from "../../const/StockData";
import { stockTypes } from "../../types/stockTypes";
import { setLoading } from "../../store/CommonSlice";
import { CustomMessage } from "../../const/Spinner";
import { enqueueSnackbar } from "notistack";
import { createStockData, deleteStockDetails, getListOfStock } from "../../api/Services/stockService";
import Swal from "sweetalert2";
import CreateStock from "../StockManagement/CreateStockInventory";
import { FILE_DOWNLOAD_PREVIEW, PAGESEND, PAGESTART } from "../../api/endpoint";
import FilterListIcon from '@mui/icons-material/FilterList';
import { getStockCodeButtonData, getStockInOutData, getStockSearchAndExportData } from "../../const/AssertData";
import { getCountryAssetMasterDataList, getFamilyAssetMasterDataList, getLocalStoreByCountryId, getProjectByRegionId, getRegionByCountryId, getStockCodeMasterDataList, getSupplierMasterDataList, saveStockCode, saveStockTransaction } from "../../api/Services/masterServie";
import { assetFamilyMaster, CountryMaster, LocalStoreMaster, StockCode, StockCodeMaster, StockTransaction } from "../../types/assetTypes";
import { getAssertButtonData } from "../../const/AssertData";
import { getStockButtonData } from "../../const/AssertData";
import "xlsx-color";
import ImagePreview from "../../Component/ImagePreview";
import { getAssetNamesByFamilyId, getUniqueAssetNamesByFamilyId, handleLogisticsFilter, handleStockFilter } from "../../api/Services/assetServices";
import CreateStockCode from "../StockManagement/CreateStockCode";
import { DropdownChangeEvent } from "primereact/dropdown";
import { Input } from "@mui/icons-material";
import { RootState } from "../../store/Reduxstore";
import RestartAltIcon from "@mui/icons-material/RestartAlt";


const StockInOut: React.FC = () => {
  const dt = useRef<DataTable<any[]>>(null);
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  const [products, setProducts] = useState<stockTypes[]>([]);
  const [selectedProducts, setSelectedProducts] = useState<any[]>([]);
  const [stockCodeId, setStockCodeId] = useState<number | null>(null);
  const overlayPanelRef = useRef<OverlayPanel>(null);
  const [selectedValue, setSelectedValue] = useState<number | null>(null);
  const [paginationData, setPaginationData] = useState<{
    page: number;
    rows: number;
    totalRecords: number;
  }>({
    page: 1,
    rows: 13,
    totalRecords: 0,
  });



  const [countryName, setCountryName] = useState<
    { label: string; value: string | null }[]
  >([]);

  useEffect(() => {
    if (countryName.length === 0) getCountryNamesList(1, PAGESEND);
  }, [countryName]);



  const [localStore, setLocalStore] = useState<
    { label: string; value: string | null }[]
  >([]);

  const [suppliers, setSuppliers] = useState<
    { label: string; value: string | null }[]
  >([]);

  useEffect(() => {
    if (suppliers.length === 0) getSupplierList(1, PAGESEND);
  }, [suppliers]);

  const getSupplierList = async (page: number, rows: number) => {
    dispatch(setLoading(true));
    try {
      const { data, status } = await getSupplierMasterDataList(
        page,
        rows,
        { supplierId: { value: "", matchMode: "startsWith" } }
      );

      if (status.code === 200 && data?.length > 0) {
        const updatedData: { label: string; value: string | null }[] = data.map(
          (val: { supplierId: number | string; supplierName: string }) => ({
            value: String(val.supplierId), // Ensure it's a string
            label: val.supplierName ?? "",          // Ensure it's a string
          })
        );

        updatedData.unshift({ label: "--Select--", value: null }); // Accept null here
        setSuppliers(updatedData);
        console.log("Mapped location data:", updatedData);
      }
    } catch (error: any) {
      CustomMessage(error?.message, "error", enqueueSnackbar);
    } finally {
      dispatch(setLoading(false));
    }
  };
  const [globalFilterValue, setGlobalFilterValue] = useState("");

  const getCountryNamesList = async (page: number, rows: number) => {
    dispatch(setLoading(true));
    try {
      const { data, status } = await getCountryAssetMasterDataList(page, rows, { currentLocationId: { value: "", matchMode: "startsWith" } });
      if (status.code === 200 && data?.length > 0) {
        const updatedData: { label: string; value: string | null }[] = data.map((val) => ({
          value: val.currentLocationId.toString(),
          label: val.countryName,
        }));
        updatedData.unshift({ label: "Select Country", value: null });
        setCountryName(updatedData);

      }
    } catch (error: any) {
      CustomMessage(error?.message, "error", enqueueSnackbar);
    } finally {
      dispatch(setLoading(false));
    }
  };

  const handleSelectFromSupplierChange = (

    _event: any,
    newValue: { label: string; value: string | null } | null
  ) => {
    if (!newValue || !newValue.value) return;

    const updatedData: Partial<StockTransaction> = { ...formData };

    updatedData.supplierName = newValue.label;
    updatedData.supplierId = parseInt(newValue.value);

    console.log("info:", updatedData);

    setFormData(updatedData as StockTransaction);


  };


  const getLocalStoreList = async (currentLocationId: number) => {
    dispatch(setLoading(true));
    try {
      const { data, status } = await getLocalStoreByCountryId(currentLocationId);

      if (status.code === 200) {
        if (data?.localStores?.length > 0) {
          const updatedData: { label: string; value: string | null }[] = data.localStores.map(
            (val: { localStoreId: number; localStoreName: string }) => ({
              value: String(val.localStoreId),
              label: val.localStoreName ?? "",
            })
          );
          setLocalStore(updatedData);
        } else {
          // 👇 If no local stores found, set to empty or default
          setLocalStore([{ label: "No Local Stores Found", value: null }]);
        }
      }
    } catch (error: any) {
      CustomMessage(error?.message, "error", enqueueSnackbar);
    } finally {
      dispatch(setLoading(false));
    }
  };


  type SelectOption = { label: string; value: string | null };

  const handleSelectCountryChange = (
    e: { target: { value: SelectOption | null } },
    name: keyof StockTransaction,
    name2: keyof StockTransaction
  ) => {
    const selected = e.target.value;

    setSelectedCountryId(selected?.value ?? null);
    setSelectedLocalStore(null);
    setStockCodes([]);
    setLocalStore([{ label: "Select Localstore", value: null }]);

    setFormData((prev) =>
      resetTransactionFields({
        transactionType: prev.transaction_type,
        countryId: selected?.value ? Number(selected.value) : null,
        countryLabel: selected?.label ?? "",
        localStoreId: null,
        localStoreLabel: "",
      })
    );

    if (selected?.value) {
      getLocalStoreList(Number(selected.value));
    } else {
      setFormData((prev) => ({
        ...prev,
        [name]: "",
        [name2]: null,
      }));
    }
  };

  const handleSelectStoresCountryChange = (
    e: any,
    name: keyof StockTransaction,
    name2: keyof StockTransaction
  ) => {
    const selected = e.target.value;

    const updatedFormData = {
      ...formData,
      [name]: selected?.label ?? "",
      [name2]: selected?.value?.toString() ?? "",
      stores_local_store_id: null,  // reset previously selected local store
      stores_localStore: "",        // clear store name too
    };

    setFormData(updatedFormData);

    const selectedCountryId = selected?.value;
    if (selectedCountryId) {
      getLocalStoreList(Number(selectedCountryId)); // fetch local stores for this country
    }
  };
  const onGlobalFilterChange = (e: { target: { value: any } }) => {
    console.log(e.target)

  };

  const exportCSV = (selectionOnly?: boolean) => {
    if (!dt.current) {
      alert("No data available to export.");
      return;
    }

    const data = dt.current.props.value || [];

    if (selectionOnly) {
      const selectedData = dt.current.props.selection || [];
      if (selectedData.length === 0) {
        alert("No rows selected for export.");
        return;
      }
      exportToExcel(selectedData);
    } else {
      exportToExcel(data);
    }
  };

  const exportToExcel = (data: any[]) => {
    if (!data || data.length === 0) {
      alert("No data to export.");
      return;
    }

    const XLSX = require("xlsx");

    const rows = data.map((row) => ({
      "Image": row.stockAttachmentId ? "Download Stock Image" : "No Attachment",
      "Stock Code": row.stockCode ?? "",
      "Item Description": row.stock_description ?? "",
      "Country": row.location_name ?? "",
      "Model/Part No": row.model_part_no ?? "",
      "Stock Category": row.stock_category ?? "",
      "Used for - Mfg": row.used_for_mfg ?? "",
      "Used for - Model": row.used_for_model ?? "",
      "Supplier": row.supplier ?? "",
      "Current Stock": row.currentStock ?? ""
    }));


    const worksheet = XLSX.utils.json_to_sheet(rows);
    const range = XLSX.utils.decode_range(worksheet["!ref"] || "");

    // Add hyperlinks for attachments
    for (let R = range.s.r + 1; R <= range.e.r; ++R) {
      const colIndex = Object.keys(rows[0]).indexOf("Attachments");
      const cellAddress = XLSX.utils.encode_cell({ r: R, c: colIndex });

      if (worksheet[cellAddress] && worksheet[cellAddress].v.startsWith("Download")) {
        const attachmentId = data[R - 1]?.attachments?.attachmentId;
        if (attachmentId) {
          worksheet[cellAddress].l = {
            Target: FILE_DOWNLOAD_PREVIEW + attachmentId,
            Tooltip: "Click to download",
          };
        }
      }
    }

    // Set column widths
    worksheet["!cols"] = Object.keys(rows[0]).map(() => ({ wch: 20 }));

    // Create and save workbook
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Stock Data");
    XLSX.writeFile(workbook, "stock_data.xlsx");
  };

  const { inputField, headerButtons } = getStockSearchAndExportData(
    globalFilterValue,
    onGlobalFilterChange,
    exportCSV
  );

  const handleAddStock = async (newStockData: any) => {
    setLoading(true);
    try {
      const response = await saveStockCode(newStockData);
      let { status } = response;
      if (status.code === 200 || status.code === 201) {
        CustomMessage(status.message, "success", enqueueSnackbar);
        CustomMessage("StockCode added successfully", "success", enqueueSnackbar);
      } else {
        CustomMessage("Failed to add the stockcode.", "error", enqueueSnackbar);
      }
    } catch (error: any) {
      CustomMessage(error?.message || "Something went wrong!", "error", enqueueSnackbar);
    } finally {
      setLoading(false);
    }
  };


  const handleDeleteAll = (selectionOnly: stockTypes[]) => {
    if (selectionOnly.length === 0) {
      return;
    }
    Swal.fire({
      title: "Are you sure?",
      text: "You won’t be able to revert this all!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "Cancel",
    }).then(async (result) => {
      if (result.isConfirmed) {
        selectionOnly.map(async (val) => {
          try {
            dispatch(setLoading(true));
            const response = await deleteStockDetails(val?.stockId);
            if (response.status === 200) {
              onFetchData(paginationData.page, paginationData.rows, filterData);
              CustomMessage("Data deleted", "success", enqueueSnackbar);
            } else {
              CustomMessage(
                "Failed to delete the asset.",
                "error",
                enqueueSnackbar
              );
            }
          } catch (error: any) {
            CustomMessage(error?.message, 'error', enqueueSnackbar);
          } finally {
            dispatch(setLoading(false));
          }
        })
      }
    });
  }
  const handleClearFilter = () => {
    const clearedFilters: Filters = {
      countryId: { value: [] },
      localStoreId: { value: [] },
      currentLocationId: { value: [] },
    };

    // Reset dropdown states
    setSelectedCountryId(null);
    setSelectedLocalStore(null);
    setStockCodes([]);
    setStockType(null);
    setFormData(defaultFormData);

    // Reset filters
    setFilterData(clearedFilters);
    setSelectedValues([]);
    setSearchText("");
    setSubAnchorEl(null);
    setAnchorEl(null);

    // Reset local store options
    setLocalStore([{ label: "--Select--", value: null }]);

    // Fetch all data again with no filters
    onFetchData(paginationData.page, paginationData.rows, clearedFilters);
  };

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [subAnchorEl, setSubAnchorEl] = useState<null | HTMLElement>(null);
  // const [filterCol, setFilterCol] = useState<string | null>(null);


  const [selectedValues, setSelectedValues] = useState<string[]>([]);
  type Column = {
    key: string;
    label: string;
    values?: string[]; // Optional if values might not always exist
  };

  const openSubPopover = (
    event: React.MouseEvent<HTMLElement>,
    col: Column
  ) => {
    setSubAnchorEl(event.currentTarget);

    setSelectedValues(col.values || []);
  };

  const closeSubPopover = () => {
    setSubAnchorEl(null);

  };
  const [columnns, setColumns] = useState<{ key: string; label: string }[]>([]);

  const closeVisibilityPopover = () => {
    setAnchorEl(null);

    setSearchText(''); // clear search input
  };
  type Filters = {
    [key: string]: {
      value: string[]; // <- expects an array
    };
  };



  type AssetItem = {
    id: number;
    name: string;
  };
  const [searchText, setSearchText] = useState("");
  type AssetColumnData = {
    [key: string]: AssetItem[];
  };
  // const [filters, setFilters] = useState<Filters>({});







  const handleSubmit = (newFilters: Filters) => {
    console.log("Submitted Filters:", newFilters);
    setFilterData(newFilters);
    onFetchData(paginationData.page, paginationData.rows, newFilters);
    closeSubPopover();
    closeVisibilityPopover();
  };



  const handleCancel = () => {

    closeSubPopover();     // ✅ Close the popover
  };



  const buttonData = getStockInOutData(
    // /initFilters,
    handleClearFilter,
    exportCSV


  );



  const handleSearch = () => {
    onFetchData(PAGESTART, PAGESEND, {}, searchText); // Call with search text
  };

  const [selectedCountryId, setSelectedCountryId] = useState<string | null>(null);
  const [selectedLocalStore, setSelectedLocalStore] = useState<string | null>(null);

  const handleSelectAssetNameChange = (
    e: DropdownChangeEvent | React.ChangeEvent<HTMLInputElement> | any,
    name: keyof StockTransaction,
    name2: keyof StockTransaction
  ) => {
    const selected = e.target.value;

    const updatedData: Partial<StockTransaction> = {
      ...formData,
      [name]: selected?.label ?? "",
      [name2]: selected?.value?.toString() ?? "",
    };

    setFormData(updatedData as StockTransaction);
  };


  const userDetails = useSelector((state: RootState) => state.auth)
  const renderHeader = () => {
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column", // stack rows
          gap: "12px",
          padding: "8px",
          width: "100%",
        }}
      >
        {/* FIRST ROW */}
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            width: "100%",
          }}
        >
          <div style={{ display: "flex", gap: "12px", alignItems: "center" }}>

            <Autocomplete
              options={countryName}
              getOptionLabel={(option) => option.label}
              value={countryName.find((c) => c.value === selectedCountryId) || null}
              onChange={(event, newValue) => {
                const selectedId = newValue?.value ?? null;
                setSelectedCountryId(selectedId);
                setSelectedLocalStore(null);
                setStockCodes([]);

                setFormData((prev) => ({
                  ...clearStockSelection(prev),
                  countryName: newValue?.label ?? "",
                  currentLocationId: newValue?.value ? Number(newValue.value) : null,
                  localStore: "",
                  localStoreId: null,
                }));

                let newFilters: Filters = {};
                if (selectedId) {
                  getLocalStoreList(Number(selectedId));
                  newFilters = {
                    ...filterData, // preserve previous filters
                    currentLocationId: { value: [selectedId] },
                  };
                  setFilterData(newFilters); // store for pagination
                  onFetchData(PAGESTART, PAGESEND, newFilters); // fetch first page with filters
                } else {
                  setLocalStore([{ label: "Select Localstore", value: null }]);
                  setFilterData({}); // reset filters
                  onFetchData(PAGESTART, PAGESEND, {}); // fetch first page without filters
                }
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  placeholder="Select a Country"
                  variant="standard"
                  sx={{ width: "180px" }}
                />
              )}
              isOptionEqualToValue={(option, value) => option.value === value.value}
            />


            {/* Local Store Dropdown */}
            <Autocomplete
              options={localStore}
              getOptionLabel={(option) => option.label}
              value={localStore.find((s) => s.value === selectedLocalStore) || null}
              onChange={(event, newValue) => {
                const selectedStore = newValue?.value ?? null;
                setSelectedLocalStore(selectedStore);

                setFormData((prev) => ({
                  ...clearStockSelection(prev),
                  localStore: newValue?.label ?? "",
                  localStoreId: newValue?.value ? Number(newValue.value) : null,
                }));

                if (selectedCountryId && selectedStore) {
                  const newFilters: Filters = {
                    ...filterData, // preserve previous filters
                    currentLocationId: { value: [selectedCountryId] },
                    localStoreId: { value: [selectedStore] },
                  };
                  setFilterData(newFilters); // update filters
                  onFetchData(PAGESTART, PAGESEND, newFilters); // fetch first page with filters
                  onFetchStockCodes(PAGESTART, PAGESEND, newFilters);
                } else {
                  setStockCodes([]);
                }
              }}
              disabled={!selectedCountryId}
              renderInput={(params) => (
                <TextField
                  {...params}
                  placeholder="Select Local Store"
                  variant="standard"
                  sx={{ width: "180px" }}
                />
              )}
              isOptionEqualToValue={(option, value) => option.value === value.value}
            />

          </div>
          {userDetails.role.some(
            (r) => r.roleName === "Admin" || r.roleName === "Stock In Out Write"
          ) && (
              <button
                onClick={() => setOpen(true)}
                style={{
                  padding: "8px 16px",
                  backgroundColor: "#28a745",
                  color: "#fff",
                  border: "none",
                  borderRadius: "4px",
                  cursor: "pointer",
                }}
              >
                Stock In/Stock Out
              </button>
            )}
        </div>
        <div style={{ display: "flex", gap: "12px", alignItems: "center" }}>
          <div style={{ display: "flex", alignItems: "center" }}>
            <input
              type="text"
              value={searchText}
              onChange={(e) => setSearchText(e.target.value)}
              placeholder="Search..."
              style={{
                padding: "6px 10px",
                borderRadius: "4px",
                border: "1px solid #ccc",
                width: "220px",
              }}
            />
            <button
              onClick={handleSearch}
              style={{
                padding: "6px 12px",
                marginLeft: "6px",
                borderRadius: "4px",
                border: "none",
                backgroundColor: "#007bff",
                color: "white",
                cursor: "pointer",
              }}
            >
              Search
            </button>
          </div>
          {buttonData &&
            buttonData.map((val) => (
              <ReusablePrimeButton key={val.label} {...val} />
            ))}
        </div>



      </div>
    );
  };
  // const renderHeader = () => {
  //   return (
  //     <div
  //       style={{
  //         display: "flex",
  //         alignItems: "center",
  //         padding: "8px",
  //         width: "100%",
  //       }}
  //     >


  //       <div style={{ display: "flex", gap: "12px" }}>

  //         <Autocomplete
  //           options={countryName}
  //           getOptionLabel={(option) => option.label}
  //           value={countryName.find((c) => c.value === selectedCountryId) || null}
  //           onChange={(event, newValue) => {
  //             const selectedId = newValue?.value ?? "";
  //             setSelectedCountryId(selectedId);

  //             setFormData((prev) => ({
  //               ...prev,
  //               countryName: newValue?.label ?? "",
  //               currentLocationId: newValue?.value ? Number(newValue.value) : null,
  //             }));

  //             if (selectedId) {
  //               getLocalStoreList(Number(selectedId));
  //               const filters: Filters = {
  //                 currentLocationId: { value: [selectedId] },
  //               };
  //               onFetchData(PAGESTART, PAGESEND, filters);
  //             } else {
  //               setLocalStore([{ label: "Select Localstore", value: null }]);
  //               setSelectedLocalStore(null);
  //               setFormData((prev) => ({
  //                 ...prev,
  //                 localStore: newValue?.label ?? "",
  //                 localStoreId: newValue?.value ? Number(newValue.value) : null,
  //               }));
  //             }
  //           }}
  //           renderInput={(params) => (
  //             <TextField
  //               {...params}
  //               placeholder="Select a Country"
  //               variant="standard"
  //               sx={{ width: "180px" }}
  //             />
  //           )}
  //           isOptionEqualToValue={(option, value) => option.value === value.value}
  //         />

  //         {/* Local Store Dropdown */}
  //         <Autocomplete
  //           options={localStore}
  //           getOptionLabel={(option) => option.label}
  //           value={localStore.find((s) => s.value === selectedLocalStore) || null}
  //           onChange={(event, newValue) => {
  //             const selectedStore = newValue?.value ?? "";
  //             setSelectedLocalStore(selectedStore);

  //             setFormData((prev) => ({
  //               ...prev,
  //               localStore: newValue?.label ?? "",
  //               localStoreId: newValue?.value ? Number(newValue.value) : null,
  //             }));

  //             const filters: Filters = {
  //               ...(selectedCountryId && {
  //                 currentLocationId: { value: [selectedCountryId] },
  //               }),
  //               ...(selectedStore && { localStoreId: { value: [selectedStore] } }),
  //             };
  //             onFetchData(PAGESTART, PAGESEND, filters);
  //           }}
  //           disabled={!selectedCountryId}
  //           renderInput={(params) => (
  //             <TextField
  //               {...params}
  //               placeholder="Select Local Store"
  //               variant="standard"
  //               sx={{ width: "180px" }}
  //             />
  //           )}
  //           isOptionEqualToValue={(option, value) => option.value === value.value}
  //         />
  //       </div>

  //       {/* RIGHT SIDE */}
  //       <div style={{ display: "flex", gap: "12px", marginLeft: "auto", alignItems: "center" }}>
  //         {/* Search Box */}
  //         <div style={{ display: "flex", alignItems: "center" }}>
  //           <input
  //             type="text"
  //             value={searchText}
  //             onChange={(e) => setSearchText(e.target.value)}
  //             placeholder="Search..."
  //             style={{
  //               padding: "6px 10px",
  //               borderRadius: "4px",
  //               border: "1px solid #ccc",
  //               width: "220px",
  //             }}
  //           />
  //           <button
  //             onClick={handleSearch}
  //             style={{
  //               padding: "6px 12px",
  //               marginLeft: "6px",
  //               borderRadius: "4px",
  //               border: "none",
  //               backgroundColor: "#007bff",
  //               color: "white",
  //               cursor: "pointer",
  //             }}
  //           >
  //             Search
  //           </button>
  //         </div>

  //         {/* Action Buttons */}
  //         {buttonData &&
  //           buttonData.map((val) => (
  //             <ReusablePrimeButton key={val.label} {...val} />
  //           ))}

  //         {/* Stock In/Out */}
  //         {userDetails.role.some(
  //           (r) => r.roleName === "Admin" || r.roleName === "Stock In Out Write"
  //         ) && (
  //           <button
  //             onClick={() => setOpen(true)}
  //             style={{
  //               padding: "8px 16px",
  //               backgroundColor: "#28a745",
  //               color: "#fff",
  //               border: "none",
  //               borderRadius: "4px",
  //               cursor: "pointer",
  //             }}
  //           >
  //             Stock In/Stock Out
  //           </button>
  //         )}
  //       </div>
  //     </div>
  //   );
  // };



  const handleDeleteStock = async (stockId: number) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won’t be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "Cancel",
    }).then(async (result) => {
      if (result.isConfirmed) {
        setLoading(true);
        try {
          const response = await deleteStockDetails(stockId);
          if (response.status === 204) {
            onFetchData(paginationData.page, paginationData.rows);
            CustomMessage("Data deleted", "success", enqueueSnackbar);
          } else {
            CustomMessage(
              "Failed to delete the asset.",
              "error",
              enqueueSnackbar
            );
          }
        } catch (error: any) {
          CustomMessage(
            error?.message || "Something went wrong!",
            "error",
            enqueueSnackbar
          );
        } finally {
          setLoading(false);
        }
      } else {
        CustomMessage("Deletion cancelled", "info", enqueueSnackbar);
      }
    });
  };

  const [stockCodes, setStockCodes] = useState<
    {
      label: string;
      value: string;
      name: {
        stockCode: string;
        stock_description: string;
        currentStock: number;
        location: string;
        unit: string;
        unitPrice: string;
      };
    }[]
  >([]);


  useEffect(() => {
    console.log("📦 Updated stockCodes:", stockCodes);
  }, [stockCodes]);


  // const handleSelectStockChange = (
  //   e: any,
  //   name: keyof StockTransaction,
  //   name2: keyof StockTransaction
  // ) => {
  //   const selected = e.target.value;

  //   if (!selected) {
  //     return;
  //   }

  //   const stockDetails = selected.name || {};

  //   const updatedFormData: StockTransaction = {
  //     ...formData,
  //     [name]: selected.label ?? "",
  //     [name2]: selected.value?.toString() ?? "",
  //     description: stockDetails.stock_description ?? "",
  //     currentStock: stockDetails.currentStock ?? "",
  //     location: stockDetails.location ?? "",
  //     unit: stockDetails.unit ?? "",
  //   };

  //   setFormData(updatedFormData);
  // };

  const handleSelectStockChange = (
    e: any,
    name: keyof StockTransaction,
    name2: keyof StockTransaction
  ) => {
    const selected = e.target.value;

    // ✅ When user clicks the X (clear)
    if (!selected) {
      setFormData((prev) => ({
        ...prev,
        stockCodeId: "",
        stockCode: "",
        description: "",
        currentStock: "",
        location: "",
        unit: "",
        unitPrice: "",
      }));
      return;
    }

    const stockDetails = selected.name || {};

    setFormData((prev) => ({
      ...prev,
      [name]: stockDetails.stockCode,
      [name2]: selected.value,

      stockCodeId: selected.value,
      stockCode: stockDetails.stockCode,
      description: stockDetails.stock_description,
      currentStock: stockDetails.currentStock,
      location: stockDetails.location,
      unit: stockDetails.unit,
      unitPrice: stockDetails.unitPrice,
    }));
  };




  const onFetchStockCodes = async (
    page: number,
    rows: number,
    filter?: Filters,
    searchTerm: string = searchText
  ) => {
    dispatch(setLoading(true));
    try {
      const response = await getListOfStock(page, rows, filter, searchTerm);
      const { data, status, pagination } = response;

      if (status.code === 200 && data != null && data.length > 0) {
        const formatted = data.map((item: any) => ({
          label: item.stock_code,
          value: item.stockCodeId?.toString() ?? "",
          name: {
            stockCode: item.stockCode,
            stock_description: item.stock_description,
            currentStock: item.currentStock,
            qty: item.qty,
            location: item.location,
            unitPrice: item.unit_price,
            unit: item.unit,

          },
        }));

        console.log("📦 Formatted Stock Codes (from useEffect):", formatted);

        setStockCodes(formatted);

        setPaginationData({
          page: pagination.currentPage,
          rows: pagination.limit,
          totalRecords: pagination.totalCount,
        });
      } else {
        setStockCodes([]);
        CustomMessage("No data", "error", enqueueSnackbar);
      }
    } catch (error: any) {
      CustomMessage(error?.message, "error", enqueueSnackbar);
    } finally {
      dispatch(setLoading(false));
    }
  };




  const onFetchData = async (page: number, rows: number, filter?: Filters, searchTerm: string = searchText) => {
    dispatch(setLoading(true));
    try {
      const response = await getListOfStock(page, rows, filter, searchTerm);
      const { data, status, pagination } = response;
      if (status.code === 200 && data != null && data?.length > 0) {
        setProducts(response.data);
        setPaginationData({
          page: pagination.currentPage,
          rows: pagination.limit,
          totalRecords: pagination.totalCount,
        });
      } else {
        setProducts([]);
        //CustomMessage("No data", "error", enqueueSnackbar);
      }
    } catch (error: any) {
      CustomMessage(error?.message, "error", enqueueSnackbar);
    } finally {
      dispatch(setLoading(false));
    }
  };

  const handleEditStock = (stockId: number) => {
    setStockCodeId(stockId);
    setOpen(true);
  };
  const actionBodyTemplate = (rowData: stockTypes) => {
    const renderIconData = stockBodyTableIcon(
      handleEditStock,
      handleDeleteStock,
      rowData
    );
    return (
      <>
        {renderIconData &&
          renderIconData.map((val, index) => (
            <ReusablePrimeButton key={index} {...val} />
          ))}
      </>
    );
  };
  const ImageRendering = (rowData: any) => {
    const attachmentId = rowData.stockAttachmentId || 0; // Fallback image
    return (
      <div className="flex align-items-center gap-2">
        {
          (attachmentId != 0 && attachmentId != null) && (
            <ImagePreview
              src={`${FILE_DOWNLOAD_PREVIEW + attachmentId}`}
              alt={`Attachment ${attachmentId}`}
              style={{
                width: "19px",
                height: "19px",
                borderRadius: "50%",
                objectFit: "cover"
              }}
            />
          )
        }
        {/* <span>{attachmentId}</span> */}
      </div>
    );
  }
  const columns = getStockColumn(actionBodyTemplate, ImageRendering);

  const [filterData, setFilterData] = useState<Record<string, any>>(() =>
    (columns ?? []).reduce((acc, col) => {
      if (col.field) {
        acc[col.field] = { value: "", matchMode: "startsWith" }; // Ensure correct structure
      }
      return acc;
    }, {} as Record<string, { value: string; matchMode: string }>),
  );

  const [stockType, setStockType] = useState<"in" | "out" | null>(null); // initially null
  const [formData, setFormData] = useState<StockTransaction>({
    transaction_type: null,
    countryName: "",

    currentLocationId: null,
    localStoreId: null,
    localStore: "",
    project_country_name: "",
    project_region_name: "",
    project_project_name: "",
    stockCodeId: "",
    stockCode: "",
    description: "",
    qty: "",
    location: "",
    newUnitPrice: "",
    po: "",
    unit: "",
    currentStock: "",
    comments: "",
    category_type: null,
    // Asset
    familyAssetId: "",
    familyName: "",
    asset_name: "",
    harmony_code: "",
    supplierId: 0,
    supplierName: "",


    // Capex
    capex_ref_num: "",
    capex_harmony_code: "",
    unitPrice: "",

    // Stores
    stores_current_location_id: null,
    stores_localStore: "",
    stores_country_name: "",
    stores_local_store_id: null,

    // Project
    project_current_location_id: null,
    project_region_id: null,
    project_project_id: null,

    created_by: null,
  });

  useEffect(() => {
    console.log("🔄 Updated formData:", formData);
  }, [formData]);

  const defaultFormData: StockTransaction = {
    transaction_type: null,
    countryName: "",
    currentStock: "",
    project_country_name: "",
    project_region_name: "",
    project_project_name: "",
    currentLocationId: null,
    localStoreId: null,
    localStore: "",
    stockCodeId: "",
    stockCode: "",
    description: "",
    qty: "",
    location: "",
    unit: "",
    stores_localStore: "",
    stores_country_name: "",
    unitPrice: "",
    po: "",
    newUnitPrice: "",
    supplierId: 0,
    supplierName: "",

    category_type: null,
    familyAssetId: "",
    familyName: "",
    asset_name: "",
    harmony_code: "",
    capex_harmony_code: "",
    comments: "",

    // Capex
    capex_ref_num: "",

    // Stores
    stores_current_location_id: null,
    stores_local_store_id: null,

    // Project
    project_current_location_id: null,
    project_region_id: null,
    project_project_id: null,

    created_by: null,
  };

  const getStockCodeFilters = (
    currentLocationId: number | string | null | undefined,
    localStoreId: number | string | null | undefined
  ): Filters | null => {
    if (!currentLocationId || !localStoreId) return null;

    return {
      currentLocationId: { value: [currentLocationId.toString()] },
      localStoreId: { value: [localStoreId.toString()] },
    };
  };

  const resetTransactionFields = ({
    transactionType,
    countryId,
    countryLabel,
    localStoreId,
    localStoreLabel,
  }: {
    transactionType: "in" | "out" | null;
    countryId: number | null;
    countryLabel: string;
    localStoreId: number | null;
    localStoreLabel: string;
  }): StockTransaction => ({
    ...defaultFormData,
    transaction_type: transactionType,
    currentLocationId: countryId,
    countryName: countryLabel,
    localStoreId,
    localStore: localStoreLabel,
  });

  const clearStockSelection = (data: StockTransaction): StockTransaction => ({
    ...data,
    stockCodeId: "",
    stockCode: "",
    description: "",
    qty: "",
    currentStock: "",
    unitPrice: "",
    newUnitPrice: "",
    location: "",
    unit: "",
    supplierId: 0,
    supplierName: "",
    po: "",
    comments: "",
    category_type: null,
    familyAssetId: "",
    familyName: "",
    asset_name: "",
    harmony_code: "",
    capex_ref_num: "",
    capex_harmony_code: "",
    stores_current_location_id: null,
    stores_country_name: "",
    stores_localStore: "",
    stores_local_store_id: null,
    project_current_location_id: null,
    project_country_name: "",
    project_region_name: "",
    project_project_name: "",
    project_region_id: null,
    project_project_id: null,
  });

  const handleSelectStoreChange = (
    e: { target: { value: SelectOption | null } },
    name: keyof StockTransaction,
    name2: keyof StockTransaction
  ) => {
    const selected = e.target.value;

    setSelectedLocalStore(selected?.value ?? null);

    const updatedFormData = clearStockSelection({
      ...formData,
      [name]: selected?.label ?? "",
      [name2]: selected?.value ? Number(selected.value) : null,
    });

    setFormData(updatedFormData);

    const filters = getStockCodeFilters(
      updatedFormData.currentLocationId,
      updatedFormData.localStoreId
    );

    if (filters) {
      onFetchStockCodes(PAGESTART, PAGESEND, filters);
    } else {
      setStockCodes([]);
    }

  };
  const handleSelectStoresLocalStoreChange = (
    e: any,
    name: keyof StockTransaction,
    name2: keyof StockTransaction
  ) => {
    const selected = e.target.value;

    const updatedFormData = {
      ...formData,
      [name]: selected?.label ?? "",
      [name2]: selected?.value?.toString() ?? "",
    };

    setFormData(updatedFormData);
  };

  const [familyAssetName, setFamilyAssetName] = useState<{ value: number; label: string }[]>([]);
  const [assetType, setAssetTypeList] = useState<{ value: number; label: string }[]>([]);
  const [assetName, setAssetNameList] = useState<
    { value: string; label: string; harmonyCode: string }[]
  >([]);


  useEffect(() => {
    if (familyAssetName.length === 0) getAssetTypeList(1, PAGESEND);
  }, [familyAssetName]);

  const getAssetTypeList = async (page: number, rows: number) => {

    console.log("Fetching asset types...");

    try {
      const { data, status } = await getFamilyAssetMasterDataList(page, rows, {
        familyAssetId: { value: "", matchMode: "startsWith" }
      });

      console.log("Asset type response:", data, status);

      if (status.code === 200 && data?.length > 0) {
        const updatedData = data.map((val) => ({
          value: val.familyAssetId,
          label: val.familyName,
        }));

        // updatedData.unshift({ label: "--Select--", value: 0 });

        setAssetTypeList(updatedData);
        console.log("Updated asset type list:", updatedData);

        setFamilyAssetName(updatedData);

      }
    } catch (error: any) {
      console.error("Error fetching asset types:", error);
      CustomMessage(error?.message, "error", enqueueSnackbar);
    }
  };

  const getAssetNameList = async (familyAssetId: number | null | undefined) => {
    if (!familyAssetId) {
      console.warn("Invalid familyAssetId:", familyAssetId);
      return;
    }

    console.log("Fetching asset names for familyAssetId:", familyAssetId);

    try {
      const { data, status } = await getAssetNamesByFamilyId(familyAssetId);

      if (status?.code === 200 && Array.isArray(data) && data.length > 0) {
        const updatedData = data.map((item: { assetName: string; harmonyCode: string }) => ({
          value: item.assetName,
          label: item.assetName,
          harmonyCode: item.harmonyCode, // ✅ include harmonyCode in the object
        }));
        setAssetNameList(updatedData);

        // updatedData.unshift({ label: "--Select--", value: "" });
        setAssetNameList(updatedData);
      } else {
        console.log("No asset names found or status is not 200");
      }
    } catch (error: any) {
      console.error("Error fetching asset names:", error);
      CustomMessage(error?.message || "Error fetching asset names", "error", enqueueSnackbar);
    }
  };

  const handleSelectAssetTypeChange = (
    e: DropdownChangeEvent | React.ChangeEvent<HTMLInputElement> | any,
    name: keyof StockTransaction,
    name2: keyof StockTransaction
  ) => {
    const selected = e.target.value;

    const updatedData: Partial<StockTransaction> = {
      ...formData,
      [name]: selected?.label ?? "",
      [name2]: selected?.value?.toString() ?? "",
      asset_name: "", // Reset asset_name on asset type change
    };

    setFormData(updatedData as StockTransaction);

    if (selected?.value) {
      getAssetNameList(selected.value);
    }
  };

  const handleSelectProjectCountryChange = (
    e: DropdownChangeEvent | React.ChangeEvent<HTMLInputElement> | any,
    name: keyof StockTransaction, // "project_country_name"
    name2: keyof StockTransaction // "project_current_location_id"
  ) => {
    const selected = (e.target as { value: { label: string; value: number } }).value;

    const updatedData: Partial<StockTransaction> = {
      ...formData,
      [name]: selected?.label || "",
      [name2]: selected?.value || null,
      project_region_name: "",
      project_region_id: null,
      project_project_name: "",
      project_project_id: null,
    };

    setFormData(updatedData as StockTransaction);

    if (selected?.value) {
      getRegionList(selected.value);
    }
  };

  const handleSelectProjectRegionChange = (
    e: DropdownChangeEvent | React.ChangeEvent<HTMLInputElement> | any,
    name: keyof StockTransaction, // "project_region_name"
    name2: keyof StockTransaction // "project_region_id"
  ) => {
    const selected = (e.target as { value: { label: string; value: number } }).value;

    const updatedData: Partial<StockTransaction> = {
      ...formData,
      [name]: selected?.label || "",
      [name2]: selected?.value || null,
      project_project_name: "",
      project_project_id: null,
    };

    setFormData(updatedData as StockTransaction);

    if (selected?.value) {
      getProjectList(selected.value);
    }
  };

  const handleSelectProjectChange = (
    e: DropdownChangeEvent | React.ChangeEvent<HTMLInputElement> | any,
    name: keyof StockTransaction, // "project_project_name"
    name2: keyof StockTransaction // "project_project_id"
  ) => {
    const selected = (e.target as { value: { label: string; value: number } }).value;

    const updatedData: Partial<StockTransaction> = {
      ...formData,
      [name]: selected?.label || "",
      [name2]: selected?.value || null,
    };

    setFormData(updatedData as StockTransaction);
  };

  const getRegionList = async (currentLocationId: number) => {

    try {
      const { data, status } = await getRegionByCountryId(currentLocationId);

      if (status.code === 200 && data?.regions?.length > 0) {
        const updatedData: { label: string; value: number }[] = data.regions.map(
          (val: { regionId: number; regionName: string }) => ({
            value: val.regionId, // Convert to string
            label: val.regionName ?? "", // Ensure it's a string
          })
        );
        // updatedData.unshift({ label: "--Select--", value: 0 });
        setRegions(updatedData);
      } else {
        // ✅ Set to empty array when no data or non-200 status
        setRegions([]);
        setFormData((prev) => ({
          ...prev,
          // projectId: "",
          regionName: ""
        }));
        // setProjects([]);
        // setFormData((prev) => ({
        //   ...prev,
        //   // projectId: "",
        //   projectName: ""
        // }));
      }


    } catch (error: any) {
      setRegions([]);
      setFormData((prev) => ({
        ...prev,
        // projectId: "",
        regionName: ""
      }));
      // setProjects([]);
      // setFormData((prev) => ({
      //   ...prev,
      //   // projectId: "",
      //   projectName: ""
      // }));
      CustomMessage(error?.message, "error", enqueueSnackbar);
    }

  };

  const getProjectList = async (regionId: number) => {

    try {
      const { data, status } = await getProjectByRegionId(regionId);

      if (status.code === 200 && data.projects.length > 0) {
        const updatedData = data.projects.map((val) => ({
          value: val.projectId.toString(),
          label: val.projectName,
        }));
        // updatedData.unshift({ label: "--Select--", value: "" });
        setProjects(updatedData);
      }
      else if (status.code === 200 && Array.isArray(data?.projects) && data.projects.length === 0) {
        setProjects([{ label: "Select Project", value: "" }]);
      }
      // ✅ Handle unexpected structure
      else {
        setProjects([{ label: "Select Project", value: "" }]);
        setFormData((prev) => ({
          ...prev,
          // projectId: "",
          projectName: ""
        }));
      }

    } catch (error: any) {
      CustomMessage(error?.message, "error", enqueueSnackbar);
    }
  };

  const [region, setRegions] = useState<
    { label: string; value: number }[]
  >([{ label: "Select a region", value: 0 }]);



  const [project, setProjects] = useState<
    { label: string; value: string | number }[]
  >([]);

  const handleSubmitStockTransaction = async () => {
    try {
      // ✅ Sanitize integer/numeric string fields
      const cleanedFormData = {
        ...formData,

        currentLocationId: Number(formData.currentLocationId) || 0,
        localStoreId: Number(formData.localStoreId) || 0,
        stores_current_location_id: Number(formData.stores_current_location_id) || 0,
        stores_local_store_id: Number(formData.stores_local_store_id) || 0,
        project_current_location_id: Number(formData.project_current_location_id) || 0,
        project_region_id: Number(formData.project_region_id) || 0,
        project_project_id: Number(formData.project_project_id) || 0,
        created_by: Number(formData.created_by) || 0,




      };

      const result = await saveStockTransaction(cleanedFormData);
      const { status } = result;

      if (status.code === 200 || status.code === 201) {
        CustomMessage(status.message || "Transaction successful", "success", enqueueSnackbar);
        const retainedCountryId = formData.currentLocationId;
        const retainedLocalStoreId = formData.localStoreId;
        const retainedCountryName = formData.countryName;
        const retainedLocalStore = formData.localStore;
        const retainedTransactionType = formData.transaction_type;
        const filters = getStockCodeFilters(retainedCountryId, retainedLocalStoreId);

        setOpen(true);
        setStockType(retainedTransactionType);
        setFormData(
          resetTransactionFields({
            transactionType: retainedTransactionType,
            countryId: retainedCountryId,
            countryLabel: retainedCountryName,
            localStoreId: retainedLocalStoreId,
            localStoreLabel: retainedLocalStore,
          })
        );

        if (filters) {
          onFetchStockCodes(PAGESTART, PAGESEND, filters);
          onFetchData(PAGESTART, PAGESEND, filters);
        } else {
          setStockCodes([]);
          onFetchData(PAGESTART, PAGESEND, {});
        }
      } else {
        if (status.message?.toLowerCase().includes("insufficient stock")) {
          CustomMessage(status.message, "error", enqueueSnackbar);
        } else {
          CustomMessage(status.message || "Something went wrong", "error", enqueueSnackbar);
        }
      }
    } catch (error: any) {
      CustomMessage(error?.message || "An error occurred", "error", enqueueSnackbar);
      console.error("Transaction error:", error);
    }
  };

  const handleResetTransaction = () => {
    setSelectedCountryId(null);
    setSelectedLocalStore(null);
    setLocalStore([{ label: "Select Localstore", value: null }]);
    setStockCodes([]);

    setFormData(
      resetTransactionFields({
        transactionType: stockType,
        countryId: null,
        countryLabel: "",
        localStoreId: null,
        localStoreLabel: "",
      })
    );
  };






  const header = renderHeader();

  return (
    <div
      style={{
        display: "flex",
        width: "100%",
        transition: "all 0.3s ease",
      }}
    >
      <div
        style={{
          flex: open ? 7 : 1,
          width: open ? "70%" : "100%",
          transition: "all 0.3s ease",
        }}
      >
        {/* Header above the data table box */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            mb: 1,
          }}
        >
          <h2
            style={{
              margin: "0 0 8px 8px",
              fontWeight: 500,
              fontSize: "18px",
            }}
          >
            Regional View
          </h2>


        </Box>

        {/* Main content box */}
        <Box
          sx={{
            backgroundColor: "#f9f9f9",
            borderRadius: 3,
            boxShadow: 3,
            padding: 2,
          }}
        >
          <ReusableDataTable
            ref={dt}
            data={products}
            columns={columns}
            onFetchData={onFetchData}
            emptyMessage="No data found."
            globalFilterFields={[
              "assetOwnerName",
              "harmonyCode",
              "codeType",
              "familyAsset",
            ]}
            header={header}
            onSelectionChange={(e) => setSelectedProducts(e.value)}
            paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
            selection={selectedProducts}
            selectionMode="multiple"
            pagination={paginationData}
            setPagination={setPaginationData}
            filters={filterData}
            setFilters={setFilterData}
          />
        </Box>
      </div>

      {/* LEFT: Data Table */}
      {/* <div
    
      style={{
        flex: open ? 7 : 1,
        width: open ? "70%" : "100%",
        transition: "all 0.3s ease",
      }}
    >
      <Box
        sx={{
          backgroundColor: "#f9f9f9",
          borderRadius: 3,
          boxShadow: 3,
          padding: 2,
        }}
      >
        <ReusableDataTable
          ref={dt}
          data={products}
          columns={columns}
          onFetchData={onFetchData}
          emptyMessage="No data found."
          globalFilterFields={["assetOwnerName", "harmonyCode", "codeType", "familyAsset"]}
          header={header}
          onSelectionChange={(e) => setSelectedProducts(e.value)}
          paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
          selection={selectedProducts}
          selectionMode="multiple"
          //rowsPerPageOptions={[10, 25, 50, 70, 100]}
          pagination={paginationData}
          setPagination={setPaginationData}
          filters={filterData}
          setFilters={setFilterData}
        />
      </Box>
    </div> */}

      {open && (
        <div
          style={{
            flex: 3,
            width: "30%",
            backgroundColor: "#fefefe",
            padding: "20px",
            borderRadius: "8px",
            marginLeft: "16px",
            display: "flex",
            flexDirection: "column",
            alignItems: "stretch",
            gap: "16px",
            border: "1px solid #ddd",
            transition: "all 0.3s ease",
            minHeight: "500px",
            maxHeight: "80vh",
            overflowY: "scroll", // scrollable
            paddingRight: "20px", // space for scrollbar
            marginRight: "-20px", // hide scrollbar
          }}
        >



          {/* Top Bar with Radio Buttons + Close Button */}
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            {/* Radio Options */}
            <div style={{ display: "flex", gap: "20px", alignItems: "center" }}>
              {/* Stock In */}
              <label style={{ display: "flex", alignItems: "center", gap: "6px", cursor: "pointer" }}>
                <input
                  type="radio"
                  name="stockType"
                  value="in"
                  checked={stockType === "in"}
                  onChange={() => {
                    setStockType("in");

                    const selectedCountry = countryName.find((c) => c.value === selectedCountryId);
                    const selectedStore = localStore.find((s) => s.value === selectedLocalStore);
                    const filters = getStockCodeFilters(selectedCountry?.value, selectedStore?.value);

                    setFormData(
                      resetTransactionFields({
                        transactionType: "in",
                        countryId: selectedCountry?.value ? Number(selectedCountry.value) : null,
                        countryLabel: selectedCountry?.label ?? "",
                        localStoreId: selectedStore?.value ? Number(selectedStore.value) : null,
                        localStoreLabel: selectedStore?.label ?? "",
                      })
                    );

                    if (filters) {
                      onFetchStockCodes(PAGESTART, PAGESEND, filters);
                    } else {
                      setStockCodes([]);
                    }
                  }}

                />
                Stock In
              </label>

              {/* Stock Out */}
              <label style={{ display: "flex", alignItems: "center", gap: "6px", cursor: "pointer" }}>
                <input
                  type="radio"
                  name="stockType"
                  value="out"
                  checked={stockType === "out"}
                  onChange={() => {
                    setStockType("out");

                    const selectedCountry = countryName.find((c) => c.value === selectedCountryId);
                    const selectedStore = localStore.find((s) => s.value === selectedLocalStore);
                    const filters = getStockCodeFilters(selectedCountry?.value, selectedStore?.value);

                    setFormData(
                      resetTransactionFields({
                        transactionType: "out",
                        countryId: selectedCountry?.value ? Number(selectedCountry.value) : null,
                        countryLabel: selectedCountry?.label ?? "",
                        localStoreId: selectedStore?.value ? Number(selectedStore.value) : null,
                        localStoreLabel: selectedStore?.label ?? "",
                      })
                    );

                    if (filters) {
                      onFetchStockCodes(PAGESTART, PAGESEND, filters);
                    } else {
                      setStockCodes([]);
                    }
                  }}

                />
                Stock Out
              </label>
            </div>


            {/* Reset + Close Buttons */}
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "8px",
              }}
            >
              <button
                type="button"
                onClick={handleResetTransaction}
                title="Reset"
                style={{
                  backgroundColor: "#f0ad4e",
                  color: "#fff",
                  border: "none",
                  padding: "5px 8px",
                  borderRadius: "4px",
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <RestartAltIcon sx={{ fontSize: 18 }} />
              </button>

              <button
                type="button"
                onClick={() => {
                  setOpen(false);
                  setStockType(null);
                }}
                style={{
                  background: "#ccc",
                  border: "none",
                  padding: "4px 8px",
                  borderRadius: "4px",
                  cursor: "pointer",
                  fontWeight: "bold",
                }}
              >
                ×
              </button>
            </div>
          </div>

          {/* Title */}
          {/* <h3 style={{ fontSize: "20px", textAlign: "center", margin: "8px 0 0 0" }}>
      {stockType === "in"
        ? "Add Stock In Details"
        : stockType === "out"
        ? "Add Stock Out Details"
        : "Select Stock Type"}
    </h3> */}

          {/* Form Content */}
          {stockType && (
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "16px",
                backgroundColor: "#fff",
                padding: "24px",
                borderRadius: "8px",
                border: "1px solid #ccc",
              }}
            >
              {stockType === "in" && (
                <div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
                  <div style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
                    {/* Country Selection */}
                    <div>
                      <h6>Select a Country</h6>
                      <FormControl fullWidth>
                        <Autocomplete
                          id="countryName"
                          aria-placeholder="Select a Country"
                          value={
                            countryName.find((item) => item.value === formData.currentLocationId?.toString()) || null
                          }
                          options={countryName}
                          getOptionLabel={(option) => option.label}
                          filterOptions={(options, { inputValue }) =>
                            options.filter((option) =>
                              option.label.toLowerCase().includes(inputValue.toLowerCase())
                            )
                          }
                          onChange={(event, newValue) =>
                            handleSelectCountryChange(
                              { target: { value: newValue } },
                              "countryName",
                              "currentLocationId"
                            )
                          }
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              variant="standard"
                              placeholder="Select or search a country"
                            />
                          )}
                          isOptionEqualToValue={(option, value) =>
                            option.value === value.value
                          }
                        />


                      </FormControl>
                    </div>

                    {/* Local Store Selection */}
                    <div>
                      <h6>Select a Local Store</h6>
                      <FormControl fullWidth>
                        <Autocomplete
                          id="localStore"
                          aria-placeholder="Select a Local Store"
                          value={
                            localStore.find((item) => item.value === formData.localStoreId?.toString()) || null
                          }
                          options={localStore}
                          getOptionLabel={(option) => option.label}
                          filterOptions={(options, { inputValue }) =>
                            options.filter((option) =>
                              option.label.toLowerCase().includes(inputValue.toLowerCase())
                            )
                          }
                          onChange={(event, newValue) =>
                            handleSelectStoreChange(
                              { target: { value: newValue } },
                              "localStore",
                              "localStoreId"
                            )
                          }
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              variant="standard"
                              placeholder="Select or search a local store"
                            />
                          )}
                          isOptionEqualToValue={(option, value) =>
                            option.value === value.value
                          }
                        />


                      </FormControl>
                    </div>

                    {/* Stock Code Selection */}
                    <div>
                      <h6>Select a Stock Code</h6>
                      <FormControl fullWidth>
                        <Autocomplete
                          id="stockCode"
                          aria-placeholder="Select a Stock Code"
                          value={
                            stockCodes.find((item) => item.value === formData.stockCodeId?.toString()) || null
                          }

                          options={stockCodes}
                          getOptionLabel={(option) => option.name.stockCode}
                          onChange={(event, newValue) =>
                            handleSelectStockChange(
                              { target: { value: newValue } },
                              "stockCode",
                              "stockCodeId"
                            )
                          }
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              variant="standard"
                              placeholder="Select a stock code"
                            />
                          )}
                          isOptionEqualToValue={(option, value) =>
                            option.value === value.value
                          }
                        />
                      </FormControl>
                    </div>

                    {/* Read-Only Fields */}
                    <div>
                      <h6>Description</h6>
                      <Autocomplete
                        id="description"
                        value={
                          stockCodes.find((item) => item.value === formData.stockCodeId?.toString()) || null
                        }
                        options={stockCodes}
                        getOptionLabel={(option) => option.name.stock_description}
                        onChange={(event, newValue) =>
                          handleSelectStockChange(
                            { target: { value: newValue } },
                            "stockCode",
                            "stockCodeId"
                          )
                        }
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            variant="standard"
                            placeholder="Select Description"
                          />
                        )}
                        isOptionEqualToValue={(option, value) =>
                          option.value === value.value
                        }
                      />
                    </div>


                    <div>
                      <h6>Add</h6>
                      <TextField
                        variant="standard"
                        fullWidth

                        value={formData.qty}
                        onChange={(e) =>
                          setFormData((prev) => ({
                            ...prev,
                            qty: e.target.value,
                          }))
                        }
                      />
                    </div>


                    <div style={{ display: "flex", gap: "16px", alignItems: "flex-start" }}>
                      {/* Current Stock */}
                      <div style={{ flex: 1 }}>
                        <h6>Current Stock</h6>
                        <TextField
                          variant="standard"
                          fullWidth
                          value={formData.currentStock}
                          InputProps={{ readOnly: true }}
                        />
                      </div>

                      {/* Old Price */}
                      <div style={{ flex: 1 }}>
                        <h6>Old Price</h6>
                        <TextField
                          variant="standard"
                          fullWidth
                          value={formData.unitPrice}
                          InputProps={{ readOnly: true }}
                        />
                      </div>
                    </div>

                    <div>
                      <h6>New Unit Price</h6>
                      <TextField
                        variant="standard"
                        fullWidth

                        value={formData.newUnitPrice}
                        onChange={(e) =>
                          setFormData((prev) => ({
                            ...prev,
                            newUnitPrice: e.target.value,
                          }))
                        }
                      />
                    </div>
                    <div>
                      <h6>Location</h6>
                      <TextField
                        variant="standard"
                        fullWidth

                        value={formData.location}
                        InputProps={{ readOnly: true }}
                      />
                    </div>

                    <div>
                      <h6>Unit</h6>
                      <TextField
                        variant="standard"
                        fullWidth

                        value={formData.unit}
                        InputProps={{ readOnly: true }}
                      />
                    </div>

                    <div>
                      <h6>Select a Supplier</h6>
                      <FormControl fullWidth>
                        <Autocomplete
                          aria-placeholder="Select a Supplier"
                          id="fromSupplier"
                          value={{
                            label: formData.supplierName ?? "",
                            value: formData.supplierId?.toString() ?? "",
                          }}
                          options={suppliers}
                          getOptionLabel={(option) => option.label}
                          onChange={(event, newValue) =>
                            handleSelectFromSupplierChange(event, newValue)
                          }
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              variant="standard" // 👈 Match currency field style
                              placeholder="Select a supplier"
                            />
                          )}
                          isOptionEqualToValue={(option, value) =>
                            option.value === value.value
                          }
                        />
                      </FormControl>
                    </div>

                    <div>
                      <h6>PO</h6>
                      <TextField
                        variant="standard"
                        fullWidth

                        value={formData.po}
                        onChange={(e) =>
                          setFormData((prev) => ({
                            ...prev,
                            po: e.target.value,
                          }))
                        }
                      />
                    </div>


                    <div>
                      <h6>Comments</h6>
                      <Box
                        component="textarea"
                        placeholder="Write your comments here..."
                        value={formData.comments}
                        onChange={(e) =>
                          setFormData((prev) => ({
                            ...prev,
                            comments: e.target.value,
                          }))
                        }
                        rows={5}
                        sx={{ width: "100%", padding: "8px", border: "1px solid #ccc", borderRadius: "4px", fontSize: "14px" }}
                      />
                    </div>


                    <Button
                      variant="contained"
                      color="primary"
                      onClick={handleSubmitStockTransaction}
                      style={{ alignSelf: "flex-end", marginTop: "16px" }}
                    >
                      Submit
                    </Button>






                  </div>

                </div>

              )}



              {stockType === "out" && (
                <div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
                  <div style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
                    {/* Country Selection */}
                    <div>
                      <h6>Select a Country</h6>
                      <FormControl fullWidth>
                        <Autocomplete
                          id="countryName"
                          aria-placeholder="Select a Country"
                          value={{
                            label: formData.countryName ?? "",
                            value: formData.currentLocationId?.toString() ?? "",
                          }}
                          options={countryName}
                          getOptionLabel={(option) => option.label}
                          onChange={(event, newValue) =>
                            handleSelectCountryChange(
                              { target: { value: newValue } },
                              "countryName",
                              "currentLocationId"
                            )
                          }
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              variant="standard"
                              placeholder="Select a country"
                            />
                          )}
                          isOptionEqualToValue={(option, value) =>
                            option.value === value.value
                          }
                        />
                      </FormControl>
                    </div>

                    {/* Local Store Selection */}
                    <div>
                      <h6>Select a Local Store</h6>
                      <FormControl fullWidth>
                        <Autocomplete
                          id="localStore"
                          aria-placeholder="Select a Local Store"
                          value={{
                            label: formData.localStore ?? "",
                            value: formData.localStoreId?.toString() ?? "",
                          }}
                          options={localStore}
                          getOptionLabel={(option) => option.label}
                          onChange={(event, newValue) =>
                            handleSelectStoreChange(
                              { target: { value: newValue } },
                              "localStore",
                              "localStoreId"
                            )
                          }
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              variant="standard"
                              placeholder="Select a local store"
                            />
                          )}
                          isOptionEqualToValue={(option, value) =>
                            option.value === value.value
                          }
                        />
                      </FormControl>
                    </div>

                    {/* Stock Code Selection */}
                    <div>
                      <h6>Select a Stock Code</h6>
                      <FormControl fullWidth>
                        <Autocomplete
                          id="stockCode"
                          value={
                            stockCodes.find((item) => item.value === formData.stockCodeId?.toString()) || null
                          }
                          options={stockCodes}
                          getOptionLabel={(option) => option.name.stockCode}
                          onChange={(event, newValue) => {
                            handleSelectStockChange(
                              { target: { value: newValue } },
                              "stockCode",
                              "stockCodeId"
                            );
                          }}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              variant="standard"
                              placeholder="Select by Stock Code"
                            />
                          )}
                          isOptionEqualToValue={(option, value) => option.value === value.value}
                        />

                      </FormControl>
                    </div>

                    {/* Read-Only Fields */}
                    <div>
                      <h6>Description</h6>
                      <Autocomplete
                        id="description"
                        value={
                          stockCodes.find((item) => item.value === formData.stockCodeId?.toString()) || null
                        }
                        options={stockCodes}
                        getOptionLabel={(option) => option.name.stock_description}
                        onChange={(event, newValue) =>
                          handleSelectStockChange(
                            { target: { value: newValue } },
                            "stockCode",
                            "stockCodeId"
                          )
                        }
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            variant="standard"
                            placeholder="Select Description"
                          />
                        )}
                        isOptionEqualToValue={(option, value) =>
                          option.value === value.value
                        }
                      />

                    </div>
                    <div>
                      <h6>Allocation</h6>
                      <TextField
                        variant="standard"
                        fullWidth

                        value={formData.qty}
                        onChange={(e) =>
                          setFormData((prev) => ({
                            ...prev,
                            qty: e.target.value,
                          }))
                        }
                      />
                    </div>


                    <div style={{ display: "flex", gap: "16px", alignItems: "flex-start" }}>
                      {/* Current Stock */}
                      <div style={{ flex: 1 }}>
                        <h6>Current Stock</h6>
                        <TextField
                          variant="standard"
                          fullWidth
                          value={formData.currentStock}
                          InputProps={{ readOnly: true }}
                        />
                      </div>

                      {/* Old Price */}
                      <div style={{ flex: 1 }}>
                        <h6>Unit  Price</h6>
                        <TextField
                          variant="standard"
                          fullWidth
                          value={formData.unitPrice}
                          InputProps={{ readOnly: true }}
                        />
                      </div>
                    </div>

                    {/* <div>
    <h6>Unit Price</h6>
    <TextField
      variant="standard"
      fullWidth
    
      value={formData.newUnitPrice}
      InputProps={{ readOnly: true }}
    />
  </div> */}

                    <div>
                      <h6>Location</h6>
                      <TextField
                        variant="standard"
                        fullWidth

                        value={formData.location}
                        InputProps={{ readOnly: true }}
                      />
                    </div>

                    <div>
                      <h6>Unit</h6>
                      <TextField
                        variant="standard"
                        fullWidth

                        value={formData.unit}
                        InputProps={{ readOnly: true }}
                      />
                    </div>

                    <div>
                      <h6>Category Type</h6>
                      <FormControl fullWidth>
                        <Select
                          value={formData.category_type || ""}
                          onChange={(e) =>
                            setFormData((prev) => ({
                              ...prev,
                              category_type: e.target.value as "Asset" | "Capex" | "Stores" | "Project" | null,

                            }))
                          }
                          displayEmpty
                          variant="standard"
                        >
                          <MenuItem value="" disabled>Select Category Type</MenuItem>
                          <MenuItem value="Asset">Asset</MenuItem>
                          <MenuItem value="Capex">Capex</MenuItem>
                          <MenuItem value="Stores">Stores</MenuItem>
                          <MenuItem value="Project">Project</MenuItem>
                        </Select>
                      </FormControl>
                    </div>

                    {formData.category_type === "Asset" && (
                      <>
                        <div>
                          <h6>Asset Type</h6>
                          <FormControl fullWidth>
                            <Select
                              value={formData.familyAssetId || ""}
                              onChange={(e) => {
                                const selected = familyAssetName.find(opt => opt.value === Number(e.target.value));

                                handleSelectAssetTypeChange({ target: { value: selected || null } }, "familyName", "familyAssetId");
                              }}
                              displayEmpty
                              variant="standard"
                            >
                              <MenuItem value="" disabled>Select an Asset Type</MenuItem>
                              {familyAssetName.map((type) => (
                                <MenuItem key={type.value} value={type.value}>{type.label}</MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                        </div>

                        <div>
                          <h6>Asset Name</h6>
                          <FormControl fullWidth>
                            <Select
                              value={formData.asset_name || ""}
                              onChange={(e) => {
                                const selected = assetName.find(opt => opt.value === e.target.value);

                                if (selected) {
                                  handleSelectAssetNameChange(
                                    { target: { value: selected } },
                                    "asset_name",
                                    "asset_name"
                                  );

                                  setFormData((prev) => ({
                                    ...prev,
                                    harmony_code: selected.harmonyCode || "",
                                  }));
                                }
                              }}


                              displayEmpty
                              variant="standard"
                            >
                              <MenuItem value="" disabled>Select an Asset Name</MenuItem>
                              {assetName.map((type) => (
                                <MenuItem key={type.value} value={type.value}>{type.label}</MenuItem>
                              ))}
                            </Select>
                          </FormControl>


                          {/* Harmony Code Input */}
                          <div style={{ marginTop: "12px" }}>
                            <h6>Harmony Code</h6>
                            <TextField
                              variant="standard"
                              fullWidth
                              value={formData.harmony_code || ""}
                              InputProps={{ readOnly: true }}
                            />

                          </div>
                        </div>

                      </>
                    )}



                    {formData.category_type === "Capex" && (
                      <div>
                        <h6>Capex Ref Number</h6>
                        <TextField
                          variant="standard"
                          fullWidth
                          value={formData.capex_ref_num || ""}
                          onChange={(e) =>
                            setFormData((prev) => ({
                              ...prev,
                              capex_ref_num: e.target.value,
                            }))
                          }
                        />

                        <h6>Capex harmony code</h6>
                        <TextField
                          variant="standard"
                          fullWidth
                          value={formData.capex_harmony_code || ""}
                          onChange={(e) =>
                            setFormData((prev) => ({
                              ...prev,
                              capex_ref_num: e.target.value,
                            }))
                          }
                        />
                      </div>

                    )}

                    {formData.category_type === "Stores" && (
                      <>
                        <div>
                          <h6>Select a Country</h6>
                          <FormControl fullWidth>
                            <Autocomplete
                              value={{
                                label: formData.stores_country_name ?? "",
                                value: formData.stores_current_location_id?.toString() ?? "",
                              }}
                              options={countryName}
                              getOptionLabel={(option) => option.label}
                              onChange={(event, newValue) =>
                                handleSelectStoresCountryChange({ target: { value: newValue } }, "stores_country_name", "stores_current_location_id")
                              }
                              renderInput={(params) => (
                                <TextField {...params} variant="standard" placeholder="Select a country" />
                              )}
                              isOptionEqualToValue={(option, value) => option.value === value.value}
                            />
                          </FormControl>
                        </div>

                        <div>
                          <h6>Select a Local Store</h6>
                          <FormControl fullWidth>
                            <Autocomplete
                              value={{
                                label: formData.stores_localStore ?? "",
                                value: formData.stores_local_store_id?.toString() ?? "",
                              }}
                              options={localStore}
                              getOptionLabel={(option) => option.label}
                              onChange={(event, newValue) =>
                                handleSelectStoresLocalStoreChange({ target: { value: newValue } }, "stores_localStore", "stores_local_store_id")
                              }
                              renderInput={(params) => (
                                <TextField {...params} variant="standard" placeholder="Select a local store" />
                              )}
                              isOptionEqualToValue={(option, value) => option.value === value.value}
                            />
                          </FormControl>
                        </div>
                      </>
                    )}

                    {formData.category_type === "Project" && (
                      <>
                        {/* Country / Current Location */}
                        <div>
                          <h6>Current Location</h6>
                          <FormControl fullWidth>
                            <Select
                              value={formData.project_current_location_id || ""}
                              onChange={(e) => {
                                const selected = countryName.find(opt => opt.value === e.target.value);
                                handleSelectProjectCountryChange(
                                  { target: { value: selected || null } },
                                  "project_country_name",
                                  "project_current_location_id"
                                );
                              }}
                              displayEmpty
                              variant="standard"
                            >
                              <MenuItem value="" disabled>Select Current Location</MenuItem>
                              {countryName.map((type) => (
                                <MenuItem
                                  key={type.value?.toString() ?? ""}
                                  value={type.value?.toString() ?? ""}
                                >
                                  {type.label}
                                </MenuItem>
                              ))}

                            </Select>
                          </FormControl>
                        </div>

                        {/* Region */}
                        <div>
                          <h6>Region</h6>
                          <FormControl fullWidth>
                            <Select
                              value={formData.project_region_id || ""}
                              onChange={(e) => {
                                const selected = region.find(opt => opt.value === e.target.value);
                                handleSelectProjectRegionChange(
                                  { target: { value: selected || null } },
                                  "project_region_name",
                                  "project_region_id"
                                );
                              }}
                              displayEmpty
                              variant="standard"
                            >
                              <MenuItem value="" disabled>Select a Region</MenuItem>
                              {region.map((reg) => (
                                <MenuItem key={reg.value} value={reg.value}>
                                  {reg.label}
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                        </div>

                        {/* Project */}
                        <div>
                          <h6>Project</h6>
                          <FormControl fullWidth>
                            <Select
                              value={formData.project_project_id || ""}
                              onChange={(e) => {
                                const selected = project.find(opt => opt.value === e.target.value);
                                handleSelectProjectChange(
                                  { target: { value: selected || null } },
                                  "project_project_name",
                                  "project_project_id"
                                );
                              }}
                              displayEmpty
                              variant="standard"
                            >
                              <MenuItem value="" disabled>Select a Project</MenuItem>
                              {project.map((proj) => (
                                <MenuItem key={proj.value} value={proj.value}>
                                  {proj.label}
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                        </div>
                      </>
                    )}

                    <div>
                      <h6>Comments</h6>
                      <Box
                        component="textarea"
                        placeholder="Write your comments here..."
                        value={formData.comments}
                        onChange={(e) =>
                          setFormData((prev) => ({
                            ...prev,
                            comments: e.target.value,
                          }))
                        }
                        rows={5}
                        sx={{ width: "100%", padding: "8px", border: "1px solid #ccc", borderRadius: "4px", fontSize: "14px" }}
                      />
                    </div>

                    <Button
                      variant="contained"
                      color="primary"
                      onClick={handleSubmitStockTransaction}
                      style={{ alignSelf: "flex-end", marginTop: "16px" }}
                    >
                      Submit
                    </Button>


                  </div>

                </div>
              )}
            </div>
          )}

        </div>
      )}



    </div>
  );
}



export default StockInOut;
